import React from "react";

export default function Gift(){
    return (
        <iframe title={'gift'} style={{width: "100%", minHeight: '100vh', border: 0, overflow: 'hidden', zIndex: 999, marginTop:60}}
                src="https://incalmo.bonkdo.com?embed=true&hide_main_title_description=false&hide_footer=false&hide_whychooseus=false&hide_create_money_pot=false&hide_group_payment=false&hide_shared_gifts_header=false&hide_whole_shared_gifts=false&hide_giftcards=false&hide_vouchers=false"></iframe>
    )
}
